module.exports = __webpack_public_path__ + "static/media/lottery_pc_bg_light.c77a75c0.png";